export default __webpack_public_path__ + "static/media/Gradle.b05115c9.svg";